import {WorkingOrderListOrderBy} from "./WorkingOrderListOrderBy";
import {OrderListColumns} from "../../list/models/OrderListColumns";

export interface OrderListConfigUpdate {
    readonly type: OrderListConfigUpdateType;
}

export enum OrderListConfigUpdateType {
    WORKING_LIST_SORTING,
    WORKING_COLUMNS,
    WORKING_ONLY_MINE,
    WORKING_INCLUDE_EXTERNAL,
    COMPLETED_COLUMNS,
    COMPLETED_INCLUDE_UN_TRADED,
    COMPLETED_ONLY_MINE,
    COMPLETED_INCLUDE_EXTERNAL
}

export interface WorkingOrderListSortingUpdate extends OrderListConfigUpdate {
    readonly type: OrderListConfigUpdateType.WORKING_LIST_SORTING;
    readonly sorting: WorkingOrderListOrderBy;
}

export function workingOrderListSortingUpdate(sorting: WorkingOrderListOrderBy): WorkingOrderListSortingUpdate {
    return {
        type: OrderListConfigUpdateType.WORKING_LIST_SORTING,
        sorting
    };
}

export function isWorkingOrderListSortingUpdate(update: OrderListConfigUpdate): update is WorkingOrderListSortingUpdate {
    return update.type === OrderListConfigUpdateType.WORKING_LIST_SORTING;
}

export interface WorkingOrderListColumnsUpdate extends OrderListConfigUpdate {
    readonly type: OrderListConfigUpdateType.WORKING_COLUMNS;
    readonly columns: OrderListColumns;
}

export function workingOrderListColumnsUpdate(columns: OrderListColumns): WorkingOrderListColumnsUpdate {
    return {
        type: OrderListConfigUpdateType.WORKING_COLUMNS,
        columns
    };
}

export function isWorkingOrderListColumnsUpdate(update: OrderListConfigUpdate): update is WorkingOrderListColumnsUpdate {
    return update.type === OrderListConfigUpdateType.WORKING_COLUMNS;
}

export interface WorkingOrderListOnlyMineUpdate extends OrderListConfigUpdate {
    readonly type: OrderListConfigUpdateType.WORKING_ONLY_MINE;
}

export function workingOrderListOnlyMineUpdate(): WorkingOrderListOnlyMineUpdate {
    return {
        type: OrderListConfigUpdateType.WORKING_ONLY_MINE
    };
}

export function isWorkingOrderListOnlyMineUpdate(update: OrderListConfigUpdate): update is WorkingOrderListOnlyMineUpdate {
    return update.type === OrderListConfigUpdateType.WORKING_ONLY_MINE;
}

export interface WorkingOrderListIncludeExternalUpdate extends OrderListConfigUpdate {
    readonly type: OrderListConfigUpdateType.WORKING_INCLUDE_EXTERNAL;
}

export function workingOrderListIncludeExternalUpdate(): WorkingOrderListIncludeExternalUpdate {
    return {
        type: OrderListConfigUpdateType.WORKING_INCLUDE_EXTERNAL
    };
}

export function isWorkingOrderListIncludeExternalUpdate(update: OrderListConfigUpdate): update is WorkingOrderListIncludeExternalUpdate {
    return update.type === OrderListConfigUpdateType.WORKING_INCLUDE_EXTERNAL;
}

export interface CompletedOrderListColumnsUpdate extends OrderListConfigUpdate {
    readonly type: OrderListConfigUpdateType.COMPLETED_COLUMNS;
    readonly columns: OrderListColumns;
}

export function completedOrderListColumnsUpdate(columns: OrderListColumns): CompletedOrderListColumnsUpdate {
    return {
        type: OrderListConfigUpdateType.COMPLETED_COLUMNS,
        columns
    };
}

export function isCompletedOrderListColumnsUpdate(update: OrderListConfigUpdate): update is CompletedOrderListColumnsUpdate {
    return update.type === OrderListConfigUpdateType.COMPLETED_COLUMNS;
}

export interface CompletedOrderToggleIncludeUnfilledUpdate extends OrderListConfigUpdate {
    readonly type: OrderListConfigUpdateType.COMPLETED_INCLUDE_UN_TRADED;
}

export function completedOrderIncludeUnfilledUpdate(): CompletedOrderToggleIncludeUnfilledUpdate {
    return {
        type: OrderListConfigUpdateType.COMPLETED_INCLUDE_UN_TRADED
    };
}

export function isCompletedOrderIncludeUnfilledUpdate(update: OrderListConfigUpdate): update is CompletedOrderToggleIncludeUnfilledUpdate {
    return update.type === OrderListConfigUpdateType.COMPLETED_INCLUDE_UN_TRADED;
}

export interface CompletedOrderOnlyMineUpdate extends OrderListConfigUpdate {
    readonly type: OrderListConfigUpdateType.COMPLETED_ONLY_MINE;
}

export function completedOrderOnlyMineUpdate(): CompletedOrderOnlyMineUpdate {
    return {
        type: OrderListConfigUpdateType.COMPLETED_ONLY_MINE
    };
}

export function isCompletedOrderOnlyMineUpdate(update: OrderListConfigUpdate): update is CompletedOrderOnlyMineUpdate {
    return update.type === OrderListConfigUpdateType.COMPLETED_ONLY_MINE;
}

export interface CompletedOrderListIncludeExternalUpdate extends OrderListConfigUpdate {
    readonly type: OrderListConfigUpdateType.COMPLETED_INCLUDE_EXTERNAL;
}

export function completedOrderListIncludeExternalUpdate(): CompletedOrderListIncludeExternalUpdate {
    return {
        type: OrderListConfigUpdateType.COMPLETED_INCLUDE_EXTERNAL
    };
}

export function isCompletedOrderListIncludeExternalUpdate(update: OrderListConfigUpdate): update is CompletedOrderListIncludeExternalUpdate {
    return update.type === OrderListConfigUpdateType.COMPLETED_INCLUDE_EXTERNAL;
}
